<!-- <app-table></app-table> -->
<!-- <app-navbar *ngIf="coreService.isLoggedIn()"></app-navbar> -->
<!-- <app-breadcrumb *ngIf="coreService.isLoggedIn()"></app-breadcrumb> -->
<!-- <app-loader></app-loader> -->
<!-- <div *ngIf="!isLoginPage() && !isRegisterPage()">
</div> -->
<!-- <p-messages></p-messages>

<router-outlet></router-outlet>
<app-footer ></app-footer> -->
<div class="app-wrapper">

  <app-navbar *ngIf="coreService.isLoggedIn()"></app-navbar>

  <app-loader></app-loader>
  <p-messages></p-messages>

  <!-- MAIN CONTENT -->
  <main class="app-content">
    <router-outlet></router-outlet>
  </main>

  <!-- FOOTER ALWAYS AT BOTTOM -->
 <app-footer *ngIf=" !coreService.isMobileMenuActive"></app-footer>

</div>
